// Who gets the Calls screen (CRM-1472): partners calling through Boom, or with
// the AI Leasing Agent — its reporting moved here from Analytics, so AI-only
// partners must not lose it. Mirrors the call-report API gate, which reports
// each kind of call only while its feature is on. Shared by the route, the
// nav link and the old Analytics tab's redirect so they never disagree.
export const canViewCallsReport = (type: {
  isCommunicationPhone?: boolean;
  isProvisionedPhoneNumber: boolean;
  isCrmAiVoiceAgent?: boolean;
}): boolean =>
  (Boolean(type.isCommunicationPhone) && type.isProvisionedPhoneNumber) ||
  Boolean(type.isCrmAiVoiceAgent);
